export default {
  title: 'Camera Events',
  filter: {
    label: 'Filters',
    active_count: '{{count}} active',
    vehicle: 'Vehicle',
    all_vehicles: 'All Vehicles',
    direction: 'Direction',
    direction_all: 'All',
    direction_in: 'Entry',
    direction_out: 'Exit',
    date_from: 'From',
    date_to: 'To',
    apply: 'Apply',
    clear: 'Clear',
  },
  card: {
    vehicle_id: 'Vehicle',
    plate: 'Plate',
    direction: 'Direction',
    score: 'Match Score',
    status: 'Status',
    view_capture: 'View Capture',
    no_plate: '—',
  },
  lightbox: {
    title: 'Capture Images',
    front: 'Front',
    rear: 'Rear',
    no_image: 'No image',
    close: 'Close',
  },
  status: {
    verified_success: 'Verified',
    verified_failed: 'Not matched',
    pending: 'Pending',
  },
  direction: {
    in: 'Entry',
    out: 'Exit',
    unknown: 'Unknown',
  },
  no_events: 'No camera events found',
  no_events_sub: 'Adjust your filters or check back later.',
  page_of: '{{page}} / {{total}}',
  loading: 'Loading events…',
}
